import { request } from '@/shared/api/request'

export const cancelAdjustmentXml = (id) => {
	return request({ url: `contract/labor/cancelRequestAdjustment/xml?id=${id}`, method: 'POST' })
}
export const cancelAdjustment = (payload) => {
	return request({ url: 'contract/labor/cancelRequestAdjustment/send', method: 'POST', data: payload })
}
